//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Constants } from '../../common/Constants';
import { IHttpInfo } from '../../logger';
import { newGuid } from '../../utilities/AppUtils';
import { AuthHelper } from '../../utilities/AuthHelper';
import { getAppHost } from '../../utilities/TeamsUtils';
import { tryParseAfdRefHeader } from '../../utilities/Utils';
import { HandleChallengeClaims } from '../ErrorHandling/HandleChallengeClaims';
export class BaseClient {
    readonly clientRequestIdHeader = Constants.CLIENT_REQUESTID_HEADER;
    private startTime: number;
    private requestId: string;
    private method: string;

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = options.headers as any;
        headers.authorization = 'Bearer ' + (await AuthHelper.getApprovalsToken());

        this.startTime = performance.now();
        if (!headers[this.clientRequestIdHeader]) {
            // set the clientRequestId if it's not present.
            headers[this.clientRequestIdHeader] = newGuid();
        }

        this.requestId = headers[this.clientRequestIdHeader];
        this.method = options.method;

        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ): Promise<any> {
        const status = response ? response.status : 0;
        const edgeRef = tryParseAfdRefHeader(response);
        if (status >= 400 || status < 200) {
            console.error(`Server request failed, url: ${url}, status ${status}`);
            await HandleChallengeClaims(response);
        }

        const regex = /\/api\/([a-zA-Z]+)/;
        const apiName = url.match(regex)[0].toString();

        // TODO: add host name
        const httpRequest: IHttpInfo = {
            apiName,
            url,
            clientRequestId: this.requestId,
            correlationId: this.requestId,
            latency: performance.now() - this.startTime,
            requestCreatedTime: this.startTime.toString(),
            responseCode: status,
            responseText: response.statusText,
            requestMethod: this.method,
            edgeRef,
        };

        getAppHost().getLogger().logHttp(httpRequest);
        return await processor(response);
    }

    protected getBaseUrl(token: string, baseUrl: string): string {
        return baseUrl ? baseUrl : MIDDLE_TIER_ENDPOINT;
    }
}

export class AuthenticationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get authentication for resource.
     * @param clientRequestId (optional) Client RequestId.
     * @param resource The resource endpoint that need authentication.
     * @return Authentication token.
     */
    getAuthenticationToken(clientRequestId: string | undefined, resource: string): Promise<string> {
        let url_ = this.baseUrl + "/api/approvals/auth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resource);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthenticationToken(_response));
        });
    }

    protected processGetAuthenticationToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the OBO token of external resource.
     * @param clientRequestId (optional) The client request Id.
     * @param input The OBO input.
     * @return The OBO output, including access token and expiry timestamp.
     */
    getAuthenticationTokenV2(clientRequestId: string | undefined, input: OnBehalfOfTokenInput): Promise<OnBehalfOfTokenOutput> {
        let url_ = this.baseUrl + "/api/approvals/auth/tokenv2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAuthenticationTokenV2(_response));
        });
    }

    protected processGetAuthenticationTokenV2(response: Response): Promise<OnBehalfOfTokenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OnBehalfOfTokenOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnBehalfOfTokenOutput>(null as any);
    }
}

export class CancelApprovalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Cancels an approval.
     * @param approvalId Approval Id to be deleted.
     * @param flowEnvironment (optional) Environment of Approvals.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with canceled approval id with response confirmation.
     */
    cancelApproval(approvalId: string, flowEnvironment: string | null | undefined, clientRequestId: string | undefined): Promise<CancelApprovalControllerOutput> {
        let url_ = this.baseUrl + "/api/cancelApproval/{approvalId}?";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "flowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelApproval(_response));
        });
    }

    protected processCancelApproval(response: Response): Promise<CancelApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelApprovalControllerOutput>(null as any);
    }
}

export class CreateApprovalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates a new approval.
     * @param input instance of CreateApprovalControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with created Approval Id.
     */
    createApproval(input: CreateApprovalControllerInput, clientRequestId: string | undefined): Promise<CreateApprovalControllerOutput> {
        let url_ = this.baseUrl + "/api/CreateApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateApproval(_response));
        });
    }

    protected processCreateApproval(response: Response): Promise<CreateApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApprovalControllerOutput>(null as any);
    }

    /**
     * Creates a new Word Addin approval.
     * @param input instance of CreateAddinApprovalControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with created Approval Id.
     */
    createAddinApproval(input: CreateAddinApprovalControllerInput, clientRequestId: string | undefined): Promise<CreateApprovalControllerOutput> {
        let url_ = this.baseUrl + "/api/CreateAddinApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAddinApproval(_response));
        });
    }

    protected processCreateAddinApproval(response: Response): Promise<CreateApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApprovalControllerOutput>(null as any);
    }
}

export class GetApprovalDetailsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get Approval details by Approval Id.
     * @param approvalId id of approval request.
     * @param flowEnvironment (optional) Environment of Approvals.
     * @param flowEndpoint (optional) Flow endpoint.
     * @param clientRequestId (optional) Client RequestId.
     * @param teamId (optional) During call from Channel, a valid Team Id will be populated.
     * @param channelId (optional) During call from Channel, a valid Channel Id will be populated.
     * @param groupId (optional) During call from Channel, a valid Group Id will be populated.
     * @param chatId (optional) During call from Chat, a valid Chat Id will be populated.
     * @return Approval Details.
     */
    getApprovalDetails(approvalId: string, flowEnvironment: string | null | undefined, flowEndpoint: string | null | undefined, clientRequestId: string | undefined, teamId: string | null | undefined, channelId: string | null | undefined, groupId: string | null | undefined, chatId: string | null | undefined): Promise<GetApprovalDetailsControllerOutput> {
        let url_ = this.baseUrl + "/api/GetApprovalDetails/{approvalId}?";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "flowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        if (flowEndpoint !== undefined && flowEndpoint !== null)
            url_ += "flowEndpoint=" + encodeURIComponent("" + flowEndpoint) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (channelId !== undefined && channelId !== null)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (chatId !== undefined && chatId !== null)
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApprovalDetails(_response));
        });
    }

    protected processGetApprovalDetails(response: Response): Promise<GetApprovalDetailsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetApprovalDetailsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetApprovalDetailsControllerOutput>(null as any);
    }

    /**
     * Get Approval details by Approval Id.
     * @param approvalId id of approval request.
     * @param documentPid Document permission id.
     * @param flowEnvironment (optional) Environment of Approvals.
     * @param clientRequestId (optional) Client RequestId.
     * @return Approval Details.
     */
    getAddinApprovalDetails(approvalId: string, documentPid: string, flowEnvironment: string | null | undefined, clientRequestId: string | undefined): Promise<GetApprovalDetailsControllerOutput> {
        let url_ = this.baseUrl + "/api/GetApprovalDetails/{approvalId}/documentPid/{documentPid}?";
        if (approvalId === undefined || approvalId === null)
            throw new Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (documentPid === undefined || documentPid === null)
            throw new Error("The parameter 'documentPid' must be defined.");
        url_ = url_.replace("{documentPid}", encodeURIComponent("" + documentPid));
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "flowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddinApprovalDetails(_response));
        });
    }

    protected processGetAddinApprovalDetails(response: Response): Promise<GetApprovalDetailsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetApprovalDetailsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetApprovalDetailsControllerOutput>(null as any);
    }
}

export class GetUserJoinedTeamsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Fetch the users for the chat context.
     * @return People Results.
     */
    getJoinedTeams(): Promise<TeamInformation[]> {
        let url_ = this.baseUrl + "/api/joinedTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJoinedTeams(_response));
        });
    }

    protected processGetJoinedTeams(response: Response): Promise<TeamInformation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamInformation[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamInformation[]>(null as any);
    }
}

export class GetUserSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get user settings.
     * @return user settings UserSettings.
     */
    getUserSettings(): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/GetUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserSettings(_response));
        });
    }

    protected processGetUserSettings(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }
}

export class ListApprovalsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get Approval details by Approval Id.
     * @param clientRequestId (optional) Client RequestId.
     * @param userRole (optional) The userRole for which listing should be done.
     * @param isDescending (optional) The value indicating whether descending or ascending order of the list should be returned.
     * @param isActive (optional) Value indicating whether only active approvals to be returned in the list or all.
     * @param nextLink (optional) The next link to query to get the remaining results.
     * @param maxNo (optional) The number of items in the list.
     * @param category (optional) Category.
     * @param flowEnvironment (optional) Environment from environment picker.
     * @param flowEndpoint (optional) Flow endpoint.
     * @param title (optional) Title keyword filter.
     * @param details (optional) Details keyword filter.
     * @param source (optional) Filter on approval sources.
     * @param excludeThumbnails (optional) Exclude user profile thumbnails from response.
     * @param shouldSkipRetrievalOfMultiLineTextFields (optional) Exclude multi line text fields from the response eg. details, additionalFields, tags, partnermetadata.
     * @return Returns Instance of ListApprovalsControllerOutput in Json format.
     */
    listApprovals(clientRequestId: string | undefined, userRole: ApprovalUserRole | undefined, isDescending: boolean | null | undefined, isActive: boolean | null | undefined, nextLink: string | null | undefined, maxNo: number | null | undefined, category: ApprovalCategory | undefined, flowEnvironment: string | null | undefined, flowEndpoint: string | null | undefined, title: string | null | undefined, details: string | null | undefined, source: string | null | undefined, excludeThumbnails: boolean | null | undefined, shouldSkipRetrievalOfMultiLineTextFields: boolean | null | undefined): Promise<ListApprovalsControllerOutput> {
        let url_ = this.baseUrl + "/api/ListApprovals?";
        if (userRole === null)
            throw new Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "userRole=" + encodeURIComponent("" + userRole) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "isDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (maxNo !== undefined && maxNo !== null)
            url_ += "maxNo=" + encodeURIComponent("" + maxNo) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "flowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        if (flowEndpoint !== undefined && flowEndpoint !== null)
            url_ += "flowEndpoint=" + encodeURIComponent("" + flowEndpoint) + "&";
        if (title !== undefined && title !== null)
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (details !== undefined && details !== null)
            url_ += "details=" + encodeURIComponent("" + details) + "&";
        if (source !== undefined && source !== null)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (excludeThumbnails !== undefined && excludeThumbnails !== null)
            url_ += "excludeThumbnails=" + encodeURIComponent("" + excludeThumbnails) + "&";
        if (shouldSkipRetrievalOfMultiLineTextFields !== undefined && shouldSkipRetrievalOfMultiLineTextFields !== null)
            url_ += "shouldSkipRetrievalOfMultiLineTextFields=" + encodeURIComponent("" + shouldSkipRetrievalOfMultiLineTextFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "List-Next-Link": nextLink !== undefined && nextLink !== null ? "" + nextLink : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListApprovals(_response));
        });
    }

    protected processListApprovals(response: Response): Promise<ListApprovalsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListApprovalsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListApprovalsControllerOutput>(null as any);
    }

    /**
     * Get list of approvals by Partner Id.
     * @param documentPermissionId (optional) Gets or sets the document permission id associated with the list of Word addin approvals.
     * @param isActive (optional) Gets or sets a value indicating whether only active approvals to be returned in the list or all.
     * @param userRole (optional) Gets or sets the userRole for which listing should be done.
     * @param isDescending (optional) Gets or sets a value indicating whether descending or ascending order of the list should be returned.
     * @param nextLink (optional) Gets or sets the next link to query to get the remaining results.
     * @param maxNo (optional) Gets or sets the number of items in the list.
     * @param category (optional) Gets or sets the approval category for which listing should be done.
     * @param flowEnvironment (optional) Gets or sets the approval environment for which listing should be done.
     * @param flowEndpoint (optional) Gets or sets the flow endpoint.
     * @param partnerId (optional) Gets or sets the partner id associated with the list of approvals.
     * @param partnerIdQueryOperator (optional) Gets or sets the query operator of partner id.
     * @param expandHistory (optional) Gets or sets a value indicating whether to expand request history or not.
     * @param expandStages (optional) Gets or sets a value indicating whether to expand stages or not.
     * @param isvId (optional) Gets or sets the Isv id.
     * @param additionalFilters_Title (optional) Gets or sets the approval title for the additional filter.
     * @param additionalFilters_Details (optional) Gets or sets the approval details for the additional filter.
     * @param additionalFilters_Source (optional) Gets or sets the approval source for the additional filter.
     * @param excludeThumbnails (optional) Gets or sets a value indicating whether user profile thumbnails should be excluded from the response.
     * @param truncateProperties (optional) Gets or sets a value indicating whether propeties should truncate or not.
     * @param shouldSkipRetrievalOfMultiLineTextFields (optional) Gets or sets a value indicating whether multilinetextFields such as PartnerMetadata should be included in the response.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns Instance of ListApprovalsControllerOutput in Json format.
     */
    listAddinApprovals(documentPermissionId: string | null | undefined, isActive: boolean | null | undefined, userRole: ApprovalUserRole | undefined, isDescending: boolean | null | undefined, nextLink: string | null | undefined, maxNo: number | null | undefined, category: ApprovalCategory | undefined, flowEnvironment: string | null | undefined, flowEndpoint: string | null | undefined, partnerId: string | null | undefined, partnerIdQueryOperator: string | null | undefined, expandHistory: boolean | undefined, expandStages: boolean | undefined, isvId: string | null | undefined, additionalFilters_Title: string | null | undefined, additionalFilters_Details: string | null | undefined, additionalFilters_Source: string | null | undefined, excludeThumbnails: boolean | null | undefined, truncateProperties: boolean | null | undefined, shouldSkipRetrievalOfMultiLineTextFields: boolean | null | undefined, clientRequestId: string | undefined): Promise<ListApprovalsControllerOutput> {
        let url_ = this.baseUrl + "/api/ListAddinApprovals?";
        if (documentPermissionId !== undefined && documentPermissionId !== null)
            url_ += "DocumentPermissionId=" + encodeURIComponent("" + documentPermissionId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (userRole === null)
            throw new Error("The parameter 'userRole' cannot be null.");
        else if (userRole !== undefined)
            url_ += "UserRole=" + encodeURIComponent("" + userRole) + "&";
        if (isDescending !== undefined && isDescending !== null)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (nextLink !== undefined && nextLink !== null)
            url_ += "NextLink=" + encodeURIComponent("" + nextLink) + "&";
        if (maxNo !== undefined && maxNo !== null)
            url_ += "MaxNo=" + encodeURIComponent("" + maxNo) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (flowEnvironment !== undefined && flowEnvironment !== null)
            url_ += "FlowEnvironment=" + encodeURIComponent("" + flowEnvironment) + "&";
        if (flowEndpoint !== undefined && flowEndpoint !== null)
            url_ += "FlowEndpoint=" + encodeURIComponent("" + flowEndpoint) + "&";
        if (partnerId !== undefined && partnerId !== null)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (partnerIdQueryOperator !== undefined && partnerIdQueryOperator !== null)
            url_ += "PartnerIdQueryOperator=" + encodeURIComponent("" + partnerIdQueryOperator) + "&";
        if (expandHistory === null)
            throw new Error("The parameter 'expandHistory' cannot be null.");
        else if (expandHistory !== undefined)
            url_ += "ExpandHistory=" + encodeURIComponent("" + expandHistory) + "&";
        if (expandStages === null)
            throw new Error("The parameter 'expandStages' cannot be null.");
        else if (expandStages !== undefined)
            url_ += "ExpandStages=" + encodeURIComponent("" + expandStages) + "&";
        if (isvId !== undefined && isvId !== null)
            url_ += "IsvId=" + encodeURIComponent("" + isvId) + "&";
        if (additionalFilters_Title !== undefined && additionalFilters_Title !== null)
            url_ += "AdditionalFilters.Title=" + encodeURIComponent("" + additionalFilters_Title) + "&";
        if (additionalFilters_Details !== undefined && additionalFilters_Details !== null)
            url_ += "AdditionalFilters.Details=" + encodeURIComponent("" + additionalFilters_Details) + "&";
        if (additionalFilters_Source !== undefined && additionalFilters_Source !== null)
            url_ += "AdditionalFilters.Source=" + encodeURIComponent("" + additionalFilters_Source) + "&";
        if (excludeThumbnails !== undefined && excludeThumbnails !== null)
            url_ += "ExcludeThumbnails=" + encodeURIComponent("" + excludeThumbnails) + "&";
        if (truncateProperties !== undefined && truncateProperties !== null)
            url_ += "TruncateProperties=" + encodeURIComponent("" + truncateProperties) + "&";
        if (shouldSkipRetrievalOfMultiLineTextFields !== undefined && shouldSkipRetrievalOfMultiLineTextFields !== null)
            url_ += "ShouldSkipRetrievalOfMultiLineTextFields=" + encodeURIComponent("" + shouldSkipRetrievalOfMultiLineTextFields) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListAddinApprovals(_response));
        });
    }

    protected processListAddinApprovals(response: Response): Promise<ListApprovalsControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListApprovalsControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListApprovalsControllerOutput>(null as any);
    }
}

export class ListEnvironmentsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get a list of Teams environments.
     * @param clientRequestId (optional) Client RequestId.
     * @return List of Environment Details.
     */
    getTeamsEnvironments(clientRequestId: string | undefined): Promise<TeamsEnvironment[]> {
        let url_ = this.baseUrl + "/api/listEnvironments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamsEnvironments(_response));
        });
    }

    protected processGetTeamsEnvironments(response: Response): Promise<TeamsEnvironment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamsEnvironment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamsEnvironment[]>(null as any);
    }
}

export class ODSPFileClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get the OneDrive item information.
     * @param clientRequestId (optional) Client RequestId.
     * @param path (optional) OneDrive item path.
     * @return OneDrive item details.
     */
    getDriveItem(clientRequestId: string | undefined, path: string | null | undefined): Promise<DriveItem> {
        let url_ = this.baseUrl + "/api/odsp/item?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDriveItem(_response));
        });
    }

    protected processGetDriveItem(response: Response): Promise<DriveItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DriveItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DriveItem>(null as any);
    }

    /**
     * Create a document sharing link.
     * @param driveId OneDrive drive id.
     * @param itemId OneDrive item id.
     * @param clientRequestId (optional) Client RequestId.
     * @param option ODSP create share link option.
     * @return Document sharing link URL.
     */
    createShareLinkWithId(driveId: string, itemId: string, clientRequestId: string | undefined, option: ODSPShareLinkOption): Promise<Permission> {
        let url_ = this.baseUrl + "/api/odsp/drives/{driveId}/items/{itemId}/createLink";
        if (driveId === undefined || driveId === null)
            throw new Error("The parameter 'driveId' must be defined.");
        url_ = url_.replace("{driveId}", encodeURIComponent("" + driveId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(option);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateShareLinkWithId(_response));
        });
    }

    protected processCreateShareLinkWithId(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Permission;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(null as any);
    }

    /**
     * Create a document sharing link.
     * @param clientRequestId (optional) Client RequestId.
     * @param input ODSP create share link input.
     * @return Document sharing link URL.
     */
    createShareLink(clientRequestId: string | undefined, input: CreateShareLinkInput): Promise<Permission> {
        let url_ = this.baseUrl + "/api/odsp/createlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateShareLink(_response));
        });
    }

    protected processCreateShareLink(response: Response): Promise<Permission> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Permission;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Permission>(null as any);
    }
}

export class PeopleResultsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Fetch the users for the chat context.
     * @param chatId Chat ID for the Teams context.
     * @param clientRequestId (optional) The unique request ID for this approval.
     * @return People Results.
     */
    getChatPeopleResultsGET(chatId: string, clientRequestId: string | undefined): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/chats/{chatId}";
        if (chatId === undefined || chatId === null)
            throw new Error("The parameter 'chatId' must be defined.");
        url_ = url_.replace("{chatId}", encodeURIComponent("" + chatId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChatPeopleResultsGET(_response));
        });
    }

    protected processGetChatPeopleResultsGET(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Filtered people result for the chat context.
     * @param chatId Chat ID for the Teams context.
     * @param clientRequestId (optional) The unique request ID for this approval.
     * @param peopleResultsControllerInput Object containing query text.
     * @return People Results.
     */
    getChatPeopleResultsPOST(chatId: string, clientRequestId: string | undefined, peopleResultsControllerInput: PeopleResultsControllerInput): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/chats/{chatId}/search";
        if (chatId === undefined || chatId === null)
            throw new Error("The parameter 'chatId' must be defined.");
        url_ = url_.replace("{chatId}", encodeURIComponent("" + chatId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(peopleResultsControllerInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChatPeopleResultsPOST(_response));
        });
    }

    protected processGetChatPeopleResultsPOST(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Fetch the users for the channel context.
     * @param teamId Team ID for the Teams context.
     * @param channelId Channel ID for the Teams context.
     * @param clientRequestId (optional) The unique request ID for this approval.
     * @param currentChannelId (optional) The channel the user is looking at. The client is expected to send this; preferred over channelId while the feature is on. See the remarks.
     * @return People Results.
     */
    getChannelPeopleResultsGET(teamId: string, channelId: string, clientRequestId: string | undefined, currentChannelId: string | null | undefined): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/teams/{teamId}/channels/{channelId}?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        if (currentChannelId !== undefined && currentChannelId !== null)
            url_ += "currentChannelId=" + encodeURIComponent("" + currentChannelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChannelPeopleResultsGET(_response));
        });
    }

    protected processGetChannelPeopleResultsGET(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Filtered people result for the chat context.
     * @param teamId Team ID for the Teams context.
     * @param channelId Channel ID for the Teams context.
     * @param clientRequestId (optional) The unique request ID for this approval.
     * @param peopleResultsControllerInput Object containing query text.
     * @param currentChannelId (optional) The channel the user is looking at. The client is expected to send this; preferred over channelId while the feature is on. See the remarks.
     * @param rosterComplete (optional) Whether the roster the client already holds is the whole channel, as reported on the read that filled the picker.
     * @return People Results.
     */
    getChannelPeopleResultsPOST(teamId: string, channelId: string, clientRequestId: string | undefined, peopleResultsControllerInput: PeopleResultsControllerInput, currentChannelId: string | null | undefined, rosterComplete: boolean | null | undefined): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/teams/{teamId}/channels/{channelId}/search?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (channelId === undefined || channelId === null)
            throw new Error("The parameter 'channelId' must be defined.");
        url_ = url_.replace("{channelId}", encodeURIComponent("" + channelId));
        if (currentChannelId !== undefined && currentChannelId !== null)
            url_ += "currentChannelId=" + encodeURIComponent("" + currentChannelId) + "&";
        if (rosterComplete !== undefined && rosterComplete !== null)
            url_ += "rosterComplete=" + encodeURIComponent("" + rosterComplete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(peopleResultsControllerInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChannelPeopleResultsPOST(_response));
        });
    }

    protected processGetChannelPeopleResultsPOST(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Fetch the users for the team context.
     * @param teamId Team ID for the Teams context.
     * @param peopleResultsControllerInput Object containing query text.
     * @return People Results.
     */
    getTeamPeopleResults(teamId: string, peopleResultsControllerInput: PeopleResultsControllerInput): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/teams/{teamId}/search";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(peopleResultsControllerInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamPeopleResults(_response));
        });
    }

    protected processGetTeamPeopleResults(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Search global users for the typed text.
     * @param clientRequestId (optional) The unique request ID for this approval.
     * @param peopleResultsControllerInput Object containing query text.
     * @return People Results.
     */
    getTenantPeopleResults(clientRequestId: string | undefined, peopleResultsControllerInput: PeopleResultsControllerInput): Promise<PeopleResult[]> {
        let url_ = this.baseUrl + "/api/users/tenant/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(peopleResultsControllerInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTenantPeopleResults(_response));
        });
    }

    protected processGetTenantPeopleResults(response: Response): Promise<PeopleResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleResult[]>(null as any);
    }

    /**
     * Fetch groups that a member is part of from the Graph.
     * @param userId The Aad Id of the user.
     * @return The list of teams/groups that the user/member is part of.
     */
    getMemberGroups(userId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/users/user/{userId}/groups";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMemberGroups(_response));
        });
    }

    protected processGetMemberGroups(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ProvisioningStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get Provisioning Status for tenant.
     * @param clientRequestId (optional) Client Request Id.
     * @return Provisioning Status.
     */
    getProvisioningStatus(clientRequestId: string | undefined): Promise<ApprovalProvisioningInfo> {
        let url_ = this.baseUrl + "/api/getProvisioningStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProvisioningStatus(_response));
        });
    }

    protected processGetProvisioningStatus(response: Response): Promise<ApprovalProvisioningInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApprovalProvisioningInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalProvisioningInfo>(null as any);
    }
}

export class ReassignApprovalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Reassigns an approval with a response.
     * @param input instance of ReassignApprovalControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with reassigned approval id with response confirmation.
     */
    reassignApproval(input: ReassignApprovalControllerInput, clientRequestId: string | undefined): Promise<ReassignApprovalControllerOutput> {
        let url_ = this.baseUrl + "/api/reassignApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReassignApproval(_response));
        });
    }

    protected processReassignApproval(response: Response): Promise<ReassignApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReassignApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReassignApprovalControllerOutput>(null as any);
    }
}

export class SendReminderClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Cancels an approval.
     * @param input Instance of SendReminderControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with approval id for which reminders were sent.
     */
    sendReminder(input: SendReminderControllerInput, clientRequestId: string | undefined): Promise<SendReminderControllerOutput> {
        let url_ = this.baseUrl + "/api/sendReminder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendReminder(_response));
        });
    }

    protected processSendReminder(response: Response): Promise<SendReminderControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SendReminderControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendReminderControllerOutput>(null as any);
    }
}

export class TacSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Controller API endpoint for getting user settings that are controlled by tenant admins.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    getTacRequestSettings(): Promise<RequestSettings> {
        let url_ = this.baseUrl + "/api/GetTacRequestSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTacRequestSettings(_response));
        });
    }

    protected processGetTacRequestSettings(response: Response): Promise<RequestSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestSettings>(null as any);
    }
}

export class Client extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * This function gets the admin settings tor the current tenant.
    only contains `RequestCommentsProvider` (for GCC only).
     * @return The esign provider settings for the tenant.
     */
    getSettings(): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/api/v1.0/settings/admin/providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettings(_response));
        });
    }

    protected processGetSettings(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }

    /**
     * The function that sets the provider flags.
    only contains `RequestCommentsProvider` (for GCC only).
     * @param providerFlags The provider flags.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    updateSettings(providerFlags: ProviderFlags): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/api/v1.0/settings/admin/providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerFlags);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSettings(_response));
        });
    }

    protected processUpdateSettings(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }
}

export class TeamTagClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Fetch the team tags for the team context.
     * @param teamId Team ID for the Teams context.
     * @param teamTagResultsControllerInput Object containing query text.
     * @return People Results.
     */
    searchTeamTagResults(teamId: string, teamTagResultsControllerInput: SearchTeamTagResultsControllerInput): Promise<TeamTagResult[]> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/tags/search";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(teamTagResultsControllerInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchTeamTagResults(_response));
        });
    }

    protected processSearchTeamTagResults(response: Response): Promise<TeamTagResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamTagResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamTagResult[]>(null as any);
    }

    /**
     * Fetch the team tag detail for the team tag.
     * @param teamId Team ID for the Teams context.
     * @param tagId Team tag Id.
     * @param expand (optional) Gets or sets the expand type.
     * @return People Results.
     */
    getTeamTagDetail(teamId: string, tagId: string, expand: ExpandValue | undefined, currentChannelId: string | undefined): Promise<TeamTagResult> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/tags/{tagId}?";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "Expand=" + encodeURIComponent("" + expand) + "&";
        if (currentChannelId === null)
            throw new Error("The parameter 'currentChannelId' cannot be null.");
        else if (currentChannelId !== undefined)
            url_ += "CurrentChannelId=" + encodeURIComponent("" + currentChannelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamTagDetail(_response));
        });
    }

    protected processGetTeamTagDetail(response: Response): Promise<TeamTagResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TeamTagResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamTagResult>(null as any);
    }
}

export class UpdateApprovalClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Updates an approval with a response.
     * @param input instance of UpdateApprovalControllerInput.
     * @param clientRequestId (optional) Client RequestId.
     * @return Returns json with updated approval id with response confirmation.
     */
    updateApproval(input: UpdateApprovalControllerInput, clientRequestId: string | undefined): Promise<UpdateApprovalControllerOutput> {
        let url_ = this.baseUrl + "/api/updateApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "x-ms-client-request-id": clientRequestId !== undefined && clientRequestId !== null ? "" + clientRequestId : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateApproval(_response));
        });
    }

    protected processUpdateApproval(response: Response): Promise<UpdateApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateApprovalControllerOutput>(null as any);
    }
}

export class UpdateUserSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Update user settings.
     * @param input user settings need to update UserSettings.
     * @return user settings UserSettings.
     */
    updateUserSettings(input: UserSettings): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/UpdateUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateUserSettings(_response));
        });
    }

    protected processUpdateUserSettings(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSettings;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }
}

export class AuditEventClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Posts an audit event.
     * @param auditEvent Audit event input.
     */
    postAuditEvent(auditEvent: AuditEvent): Promise<void> {
        let url_ = this.baseUrl + "/api/esign/auditEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(auditEvent);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPostAuditEvent(_response));
        });
    }

    protected processPostAuditEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CreateAdaptiveCardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates an adaptive card.
     * @param input Input for creating the adaptive card.
     * @return A task containing the message id.
     */
    createAdaptiveCard(input: CreateAdaptiveCardControllerInput): Promise<CreateAdaptiveCardControllerOutput> {
        let url_ = this.baseUrl + "/api/esign/createAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAdaptiveCard(_response));
        });
    }

    protected processCreateAdaptiveCard(response: Response): Promise<CreateAdaptiveCardControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdaptiveCardControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdaptiveCardControllerOutput>(null as any);
    }
}

export class DeleteAdaptiveCardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Creates an adaptive card.
     * @param input Input for creating the adaptive card.
     * @return A task.
     */
    deleteAdaptiveCard(input: DeleteAdaptiveCardControllerInput): Promise<void> {
        let url_ = this.baseUrl + "/api/esign/deleteAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAdaptiveCard(_response));
        });
    }

    protected processDeleteAdaptiveCard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Controller API endpoint for getting user settings that are controlled by tenant admins.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    getProviderFlags(): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/api/esign/settings/user/providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProviderFlags(_response));
        });
    }

    protected processGetProviderFlags(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }
}

/** The data mode of the OBO output. */
export interface OnBehalfOfTokenOutput {
    /** Gets or sets tThe resource of the OBO token. */
    Resource?: string | undefined;
    /** Gets or sets the access token. */
    AccessToken?: string | undefined;
    /** Gets or sets the timestamp when the token would be expired. */
    ExpiresOn: string;
}

/** The data model of the OBO input. */
export interface OnBehalfOfTokenInput {
    /** Gets or sets the resource of the OBO input. */
    Resource?: string | undefined;
    /** Gets or sets a value indicating whether to use the token cache or a force refresh is desired. */
    ForceRefresh: boolean;
    /** Gets or sets the claims of the OBO input. */
    Claims?: string | undefined;
    /** Gets or sets the scope of the OBO input. */
    Scope?: string | undefined;
}

/** Data object used to call the cancel approval controller. */
export interface CancelApprovalControllerOutput {
    /** Gets or sets the id of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval. */
    Properties?: CancelApprovalOutputProperties | undefined;
}

/** Data object outlining response from flow's cancel approval API. */
export interface CancelApprovalOutputProperties {
    /** Gets or sets the title of the approval. */
    Title?: string | undefined;
    /** Gets or sets the owner of the approval. */
    Owner?: ApprovalCreatorOwner | undefined;
    /** Gets or sets the creator of the approval. */
    Creator?: ApprovalCreatorOwner | undefined;
    /** Gets or sets the result of the approval. */
    Result?: string | undefined;
    /** Gets or sets the creation date of the approval. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date of the approval. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date of the approval. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the completion date of the approval. */
    CompletionDate?: string | undefined;
    /** Gets or sets a value indicating whether ancelling is allowed. */
    AllowCancel: boolean;
    /** Gets or sets a value indicating whether reassigning is allowed. */
    AllowReassign: boolean;
    /** Gets or sets the status of the approval. */
    Status?: string | undefined;
    /** Gets or sets the stage of the approval. */
    Stage?: string | undefined;
}

/** Data object of owner within properties of the update approval response from flow. */
export interface ApprovalCreatorOwner {
    /** Gets or sets aad id of the owner of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the tenant id of the owner of the approval. */
    TenantId?: string | undefined;
}

/** Output data object for get approval controller. */
export interface GetApprovalDetailsControllerOutput {
    /** Gets or sets the name of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval view. */
    Properties?: ApprovalViewProperties | undefined;
}

/** Data object returned after creating approval. */
export interface CreateApprovalControllerOutput extends GetApprovalDetailsControllerOutput {
    /** Gets or sets the approvalId of request. */
    ApprovalId?: string | undefined;
}

/** The approval view properties. This is a translation of the approval entity into an object better suited to be consumed by the UI. */
export interface ApprovalViewProperties {
    /** Gets or sets the type of the approval. */
    Type?: ApprovalResponseType | undefined;
    /** Gets or sets a value indicating whether the approval is active or not. */
    IsActive: boolean;
    /** Gets or sets the roles of the user in the approval. */
    UserRoles?: ApprovalUserRole[] | undefined;
    /** Gets or sets the Owner of approval request. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets the creator, person who owns the connection. */
    Creator?: UserPrincipal | undefined;
    /** Gets or sets the userRequest of the approval. */
    UserRequest?: ApprovalRequestViewDefinition | undefined;
    /** Gets or sets the userRequest history of the approval. */
    UserRequestHistory?: ApprovalRequestHistoryDefinition[] | undefined;
    /** Gets or sets the responses of the approval. */
    Stages?: ApprovalStageViewDefinition[] | undefined;
    /** Gets or sets the title of the approval. */
    Title?: string | undefined;
    /** Gets or sets the description of the approval. */
    Details?: string | undefined;
    /** Gets or sets the result of the approval. */
    Result?: string | undefined;
    /** Gets or sets whether canceling the approval is allowed or not. */
    AllowCancel?: boolean | undefined;
    /** Gets or sets a value indicating whether EmailNotification are enabled or not. */
    EnableEmailNotifications?: boolean | undefined;
    /** Gets or sets whether request of the approval can be reassigned. */
    AllowReassign?: boolean | undefined;
    /** Gets or sets the optional item associated with an approval. */
    Item?: ApprovalItemDefinition | undefined;
    /** Gets or sets the optional link attachments associated with an approval. */
    TextAttachments?: ApprovalsTextAttachment[] | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the completion date. */
    CompletionDate?: string | undefined;
    /** Gets or sets the array of approver oids assigned to the approval. */
    Approvers?: string[] | undefined;
    /** Gets or sets the list of prinicpals involved with the approval. */
    Principals?: UserPrincipal[] | undefined;
    /** Gets or sets the list of attachment metadata associated with the approval. */
    Attachments?: ApprovalAttachmentDefinition[] | undefined;
    /** Gets or sets the approval type. */
    ApprovalType: ApprovalType;
    /** Gets or sets the links used to review an envelope for esign. */
    EsignReviewLinks?: ApprovalAttachmentDefinition[] | undefined;
    /** Gets or sets the request type. */
    RequestType: ApprovalRequestType;
    /** Gets or sets the category of the approval. */
    Category?: string | undefined;
    /** Gets or sets the Id of the template with which the approval is created. */
    TemplateId?: string | undefined;
    /** Gets or sets the Id of the form in the template with which the approval is created. */
    TemplateFormId?: string | undefined;
    /** Gets or sets the Id of the form response user sumbitted to create the approval. */
    TemplateResponseId?: string | undefined;
    /** Gets or sets the ApprovalTemplateInstanceBasicView. Only for templated approvals. */
    TemplateInstance?: ApprovalTemplateInstanceBasicView | undefined;
    /** Gets or sets the key value pairs of Form response details. */
    FormResponseDetails?: KeyValuePairOfStringAndString[] | undefined;
    /** Gets or sets the PartnerId.
            
Note: for legacy approvals, this property is the hashed value of the PartnerId instead of the original value. */
    PartnerId?: string | undefined;
    /** Gets or sets the PartnerMetadata Object. */
    PartnerMetadata?: ApprovalsPartnerMetadata | undefined;
    /** Gets or sets generic additional view properties. */
    AdditionalViewProperties?: { [key: string]: any; } | undefined;
    /** Gets or sets approval external id. */
    ExternalId?: string | undefined;
    /** Gets or sets the source of the approval. */
    Source?: string | undefined;
    /** Gets or sets the priority of the approval. */
    Priority?: Priority | undefined;
    /** Gets or sets current approval step number. */
    CurrentStepNumber?: number | undefined;
    /** Gets or sets the approval's additional fields. */
    AdditionalFields?: AdditionalField[] | undefined;
}

/** Approval response types. */
export enum ApprovalResponseType {
    NotSpecified = 0,
    Basic = 1,
    BasicAwaitAll = 2,
    CustomResponse = 3,
    CustomResponseAwaitAll = 4,
    Sequential = 5,
}

/** The role of a user in an approval. */
export enum ApprovalUserRole {
    NotSpecified = 0,
    Owner = 1,
    Approver = 2,
    DelegatedAccess = 3,
}

/** The UserPrincipal object. */
export interface UserPrincipal {
    /** Gets or sets the principal id. */
    Id?: string | undefined;
    /** Gets or sets the principal display name. */
    DisplayName?: string | undefined;
    /** Gets or sets the principal email. */
    Email?: string | undefined;
    /** Gets or sets the principal object tenant id. */
    TenantId?: string | undefined;
    /** Gets or sets the user principal name. */
    UserPrincipalName?: string | undefined;
    /** Gets or sets the base64 encoded thumbnail photo uri. */
    ThumbnailPhoto?: string | undefined;
    /** Gets or sets the principal object type. */
    Type?: PrincipalObjectType | undefined;
}

/** The principal object type enumeration. */
export enum PrincipalObjectType {
    NotSpecified = 0,
    User = 1,
    Group = 2,
    Claims = 3,
    DelegatedAdmin = 4,
    ServicePrincipal = 5,
}

/** The ApprovalRequestViewDefinition from Flow. */
export interface ApprovalRequestViewDefinition {
    /** Gets or sets the stage of the name of the approval request. */
    Name?: string | undefined;
    /** Gets or sets the stage of the associated approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the user to which this request is assigned. */
    AssignedTo?: UserPrincipal | undefined;
    /** Gets or sets a value indicating whether the approval request may be reassigned. */
    AllowReassignment?: boolean | undefined;
    /** Gets or sets a value indicating whether the approval request has been reassigned. */
    IsReassigned?: boolean | undefined;
    /** Gets or sets the name of the approval request from which this was reassigned. */
    ReassignedFrom?: string | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the schema of the additional data that the approver may provide. */
    AdditionalParametersSchema?: any | undefined;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the partner metadata. */
    PartnerMetadata?: ApprovalRequestPartnerMetadata | undefined;
}

/** The stage of an approval or an approval request. */
export enum ApprovalStage {
    NotSpecified = 0,
    Basic = 1,
    Complete = 2,
}

/** PartnerMetadata Object for Approval request. */
export interface ApprovalRequestPartnerMetadata {
    /** Gets or sets the datetime when approval request was last viewed. */
    LastViewedOn?: string | undefined;
    /** Gets or sets the datetime when requester was last notified. */
    LastNotifiedOn?: string | undefined;
    /** Gets or sets the custom status of the approval request. */
    Status?: string | undefined;
}

/** Output data object for get approval controller. */
export interface ApprovalRequestHistoryDefinition {
    /** Gets or sets the name of the approval request. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval request. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval request. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval request. */
    Properties?: ApprovalRequestHistoryProperties | undefined;
}

/** The ApprovalRequestHistoryDefinition. */
export interface ApprovalRequestHistoryProperties {
    /** Gets or sets the stage of the associated approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the creation date. */
    CreationDate?: string | undefined;
    /** Gets or sets the due date. */
    DueDate?: string | undefined;
    /** Gets or sets the expiration date. */
    ExpirationDate?: string | undefined;
    /** Gets or sets the user to which this request is assigned. */
    AssignedTo?: UserPrincipal | undefined;
    /** Gets or sets the notification frequency. */
    NotificationFrequency: number;
    /** Gets or sets a value indicating whether the approval request may be reassigned. */
    AllowReassignment?: boolean | undefined;
    /** Gets or sets a value indicating whether the approval request has been reassigned. */
    IsReassigned?: boolean | undefined;
    /** Gets or sets the name of the approval request from which this was reassigned. */
    ReassignedFrom?: ApprovalRequestHistoryDefinition | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the response option type. */
    ResponseOptionsType?: string | undefined;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the partner metadata. */
    PartnerMetadata?: ApprovalRequestPartnerMetadata | undefined;
}

/** The approval stage view definition. This definition is an abstraction of the requests and responses per a specific stage of an approval. Used as an array of approval stage view definitions to form a timeline of each stage of an approval. */
export interface ApprovalStageViewDefinition {
    /** Gets or sets the name of the stage of the approval. */
    Stage?: ApprovalStage | undefined;
    /** Gets or sets the responses of the stage of the approval. */
    Responses?: ApprovalResponseViewDefinition[] | undefined;
}

/** The approval response view definition. This is a translation of the approval response entity into an object better suited to be consumed by the UI. This does not use any of the standard ARM properties present in the non-view versions as this definition. This is also used to select an audience of the approval notification in case, where partially approved request was followed with reminder notification request. */
export interface ApprovalResponseViewDefinition {
    /** Gets or sets the creation date. */
    CreationDate: string;
    /** Gets or sets the owner. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets the approver's response. */
    Response?: string | undefined;
    /** Gets or sets the approver's comments. */
    Comments?: string | undefined;
    /** Gets or sets the additional data that the approver may provide. */
    AdditionalParameters?: { [key: string]: any; } | undefined;
    /** Gets or sets the Order of response. */
    Order: number;
    /** Gets or sets the step number. */
    StepNumber?: number | undefined;
    /** Gets or sets the additional fields. */
    AdditionalFields?: { [key: string]: string; } | undefined;
}

/** The approval item definition. */
export interface ApprovalItemDefinition {
    /** Gets or sets the link to the item to approve. */
    Link?: string | undefined;
    /** Gets or sets the display name for the item link. */
    DisplayName?: string | undefined;
}

/** Link attachments that require to be approved. */
export interface ApprovalsTextAttachment {
    /** Gets or sets the subject. */
    Subject?: string | undefined;
    /** Gets or sets the link. */
    NoteText?: string | undefined;
}

/** The approval definition. */
export interface ApprovalAttachmentDefinition {
    /** Gets or sets the unqiue identifier. */
    Id?: string | undefined;
    /** Gets or sets the name. */
    Name?: string | undefined;
    /** Gets or sets the link. */
    Link?: string | undefined;
}

/** The types of approvals that users can create, maps to the Request type drop down in UI. */
export enum ApprovalType {
    Basic = 0,
    ESign = 1,
    Templated = 2,
}

/** Approval Request Type. */
export enum ApprovalRequestType {
    NotSpecified = 0,
    Other = 1,
    Basic = 2,
    Esign = 3,
    Templates = 4,
}

/** Data model of the basic info of the ApprovalTemplateInstance. */
export interface ApprovalTemplateInstanceBasicView {
    /** Gets or sets the title of the template instance. */
    Title?: string | undefined;
    /** Gets or sets the description of the template instance. */
    Description?: string | undefined;
    /** Gets or sets the icon name of the template instance. */
    IconName?: string | undefined;
    /** Gets or sets the icon color of the template instance. */
    AccentColor?: string | undefined;
    /** Gets or sets the category of the template instance. */
    Category: ApprovalTemplateCategory;
    /** Gets or sets the scope of the template instance. */
    Scope: ApprovalTemplateInstanceScopeType;
    /** Gets or sets the teamId of the template instance. this is actually the groupId of the team, and this field is only for Team scoped template instances. */
    TeamId?: string | undefined;
    /** Gets or sets whether the requests created by this template requires approvers comments, default to null. */
    IsApproverCommentsRequired?: boolean | undefined;
    /** Gets or sets the Id of form. */
    FormId?: string | undefined;
}

/** The enum definition of categories of ApprovalTemplateInstance. */
export enum ApprovalTemplateCategory {
    NotSpecified = 0,
    Attendance = 1,
    Administration = 2,
    Finance = 3,
    Activity = 4,
    OrderManagement = 5,
    Personnel = 6,
    Contract = 7,
    HealthCare = 8,
    WordAddin = 9,
}

/** The enum definition of ApprovalTemplateInstance scope. */
export enum ApprovalTemplateInstanceScopeType {
    Organization = 0,
    Team = 1,
}

export interface KeyValuePairOfStringAndString {
    Key?: string | undefined;
    Value?: string | undefined;
}

/** PartnerMetadata Object for Approvals. */
export interface ApprovalsPartnerMetadata {
    /** Gets or sets approvalsTemplateResponse details. */
    ApprovalsTemplateResponse?: ApprovalsTemplateResponseItem[] | undefined;
    /** Gets or sets the viva amplify additional information. */
    VivaAmplifyAdditionalDetails?: VivaAmplifyAdditionalDetails | undefined;
    /** Gets or sets the Syntex Esign additional information. */
    SyntexESignMetadata?: SyntexESignMetadata | undefined;
    /** Gets or sets other properties in the metadata.
It's preferred to define a strong type property when you add a new field in the metadata. */
    AdditionalData?: { [key: string]: any; } | undefined;
}

/** ResponseItem (Answer + Question Snapshot) for Template Approvals. */
export interface ApprovalsTemplateResponseItem {
    /** Gets or sets id map the form question. */
    questionId?: string | undefined;
    /** Gets or sets question type. */
    type: TemplateQuestionType;
    /** Gets or sets question anwser string or jsonstring. */
    answer?: string | undefined;
    /** Gets or sets question title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this field is required. */
    required: boolean;
    /** Gets or sets all choices of the question. */
    chocies?: string[] | undefined;
    /** Gets or sets Froms Rich Text Title. */
    formsProRTQuestionTitle?: string | undefined;
}

/** Quesiton Type. Save and transfer this data as string. [EnumMember(Value = "xx")] dose not work with System.Text.Json. So we use under line to split subtype.the enum filed name cannot be changed once published. */
export enum TemplateQuestionType {
    TextField_Single = "TextField_Single",
    TextField_Multiline = "TextField_Multiline",
    Choice_SingleRadio = "Choice_SingleRadio",
    Choice_SingleDropdown = "Choice_SingleDropdown",
    Choice_MultiCheckbox = "Choice_MultiCheckbox",
    DateTime_Default = "DateTime_Default",
    TextField_Number = "TextField_Number",
}

/** Addtional details for the Viva Amplify approvals. */
export interface VivaAmplifyAdditionalDetails {
    /** Gets or sets the teams Id. */
    teamsId?: string | undefined;
    /** Gets or sets the Channel id. */
    channelId?: string | undefined;
    /** Gets or sets the publish date of the item in UTC format. */
    scheduledPublishDate?: string | undefined;
    /** Gets or sets the approval type of the viva campaign communication. */
    approvalType?: string | undefined;
    /** Gets or sets the message from the requestor. */
    messageFromRequestor?: string | undefined;
    /** Gets or sets the distribution channel. */
    distributionChannel?: DistributionChannel[] | undefined;
    /** Gets or sets the publish option for Item. */
    publishOption?: PublishOption | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemTitle?: string | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemAbstract?: string | undefined;
    /** Gets or sets the url of the campaign approval item. */
    itemUrl?: string | undefined;
    /** Gets or sets the preview image of the campaign approval item. */
    itemPreviewImageUrl?: string | undefined;
}

/** Enum for the distribution channels. */
export enum DistributionChannel {
    Outlook = "outlook",
    Sharepoint = "sharepoint",
    Teams = "teams",
    VivaEngage = "vivaengage",
}

/** Enum for the publish option. */
export enum PublishOption {
    ScheduledFor = "scheduledFor",
    PublishOnceApproved = "publishOnceApproved",
    ReviewBeforePublish = "reviewBeforePublish",
}

/** Additional Details for Syntex Esign Approvals. */
export interface SyntexESignMetadata {
    /** Gets or sets the locale for the approval. */
    Locale?: string | undefined;
    /** Gets or sets the target folder for the Esign documents. */
    TargetFolder?: string | undefined;
    /** Gets or sets the documents associated with the approval. */
    Documents?: SyntexESignDocument[] | undefined;
    /** Gets or sets the message associated with the approval. */
    Message?: string | undefined;
    /** Gets or sets the status associated with the approval. */
    Status?: number | undefined;
}

/** Syntex Esign Document Object. */
export interface SyntexESignDocument {
    /** Gets or sets the name of the Syntex document. */
    Name?: string | undefined;
    /** Gets or sets the Uri for the Syntex document. */
    Uri?: string | undefined;
}

/** The priority of the approval. */
export enum Priority {
    Low = 0,
    Medium = 1,
    Important = 2,
}

export interface AdditionalField {
    /** Gets or sets the id of the additional field. */
    Id?: string | undefined;
    /** Gets or sets the title of the additional field. */
    Title?: string | undefined;
    /** Gets or sets the description of the additional field. */
    Description?: string | undefined;
    /** Gets or sets the content of the additional field. */
    Content?: string | undefined;
}

/** Data object used to call the create approval handler. */
export interface CreateApprovalControllerInput {
    /** Gets or sets the creator of approval request. */
    Creator?: ApprovalCreator | undefined;
    /** Gets or sets the Name of user. */
    UserName?: string | undefined;
    /** Gets or sets the Email of user. */
    UserEmail?: string | undefined;
    /** Gets or sets the title. */
    Title?: string | undefined;
    /** Gets or sets the users AadId to which the approval is assigned. An array of user AadIds. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the type of approval to create. */
    Type: ApprovalResponseType;
    /** Gets or sets the notification url. */
    CallbackUrls?: string[] | undefined;
    /** Gets or sets the details. */
    Details?: string | undefined;
    /** Gets or sets the item to approve. */
    Item?: ApprovalItem | undefined;
    /** Gets or sets the Text Attachment to approve. */
    TextAttachments?: ApprovalsTextAttachment[] | undefined;
    /** Gets or sets the response options for the custom response approval. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the ClientRequestId for approval request. */
    ClientRequestId: string;
    /** Gets or sets the Approval Type. */
    ApprovalType: ApprovalType;
    /** Gets or sets the logger properties for a scenario coming in from client-side. */
    ScenarioLoggerProperties?: AriaScenarioLoggerProperties | undefined;
    /** Gets or sets a value indicating whether the tenant is provisioning with this action. */
    FirstTimeProvisioning?: boolean | undefined;
    /** Gets or sets the environment in which Approval is created. */
    FlowEnvironment?: string | undefined;
    /** Gets or sets the Approvals User Token. This is used for bot context messages extension submit action. */
    UserToken?: string | undefined;
    /** Gets or sets the category of the approval. */
    Category?: string | undefined;
    /** Gets or sets the Id of the template with which the approval is created. */
    TemplateId?: string | undefined;
    /** Gets or sets the Id of the form response user submitted to create the approval. */
    TemplateResponseId?: string | undefined;
    /** Gets or sets the source of the approval. */
    Source?: string | undefined;
    /** Gets or sets the priority of the approval. */
    Priority?: Priority | undefined;
    /** Gets or sets the PartnerMetadata Object. */
    PartnerMetadata?: ApprovalsPartnerMetadata | undefined;
    /** Gets or sets the Steps Object. */
    Steps?: ApprovalStepSettingInput[] | undefined;
    /** Gets or sets the Answers of the report. */
    Answers?: AnswerByQuestion[] | undefined;
}

/** Creator of approval request. */
export enum ApprovalCreator {
    PersonalApp = 0,
    ChatMessage = 1,
    ChannelPost = 2,
    WordAddIn = 3,
    ApprovalGraph = 4,
    UnSpecified = 5,
}

/** Items that requires to be approved. */
export interface ApprovalItem {
    /** Gets or sets the item link. */
    Link?: string | undefined;
    /** Gets or sets the item link description. */
    LinkDescription?: string | undefined;
}

/** Aria logger properties received from client-side. */
export interface AriaScenarioLoggerProperties {
    /** Gets or sets the session ID. */
    SessionId: string;
    /** gets or sets the scenario name. */
    ScenarioName?: string | undefined;
    /** gets or sets the scenario name. */
    StepName?: string | undefined;
    /** gets or sets the status. */
    Status?: string | undefined;
    /** gets or sets the approval id. */
    ApprovalId?: string | undefined;
    /** gets or sets additional data received from telemetry logger. */
    Data?: any | undefined;
}

/** Settings for one step in Sequential approval. */
export interface ApprovalStepSettingInput {
    /** Gets or sets the users to which the approval is assigned as approvers.
An array of Object IDs or Emails. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the approval policy. */
    ApprovalPolicy: ApprovalPolicyType;
}

/** The approval policy: any ,all. */
export enum ApprovalPolicyType {
    Any = 1,
    All = 2,
}

/** The data model of AnswerByQuestion. The answer can be identified by the question id in a report context. */
export interface AnswerByQuestion {
    /** Gets or sets the QuestionId. */
    QuestionId?: string | undefined;
    /** Gets or sets the AnswerContent. */
    AnswerContent?: string | undefined;
}

/** Data object used to call the create addin approval controller. */
export interface CreateAddinApprovalControllerInput extends CreateApprovalControllerInput {
    /** Gets or sets the document id. */
    DocumentPermissionId?: string | undefined;
}

/** The team information . */
export interface TeamInformation {
    /** Gets or Sets TeamId. */
    TeamId?: string | undefined;
    /** Gets or Sets TeamName. */
    TeamName?: string | undefined;
    /** Gets or Sets TeamDescription. */
    TeamDescription?: string | undefined;
    /** Gets or Sets ThumbnailUri. */
    ThumbnailUri?: string | undefined;
    /** Gets or Sets GroupId. */
    GroupId?: string | undefined;
    /** Gets or Sets UserTeamRole. */
    UserTeamRole: UserTeamRole;
    /** Gets or Sets TeamType. */
    TeamType?: string | undefined;
    /** Gets or sets a value indicating whether team is locked. */
    IsTeamLocked: boolean;
    /** Gets or sets a value indicating whether team is archived. */
    IsTeamArchived?: string | undefined;
}

/** The user team role enum. */
export enum UserTeamRole {
    Admin = 0,
    User = 1,
    Guest = 2,
}

/** Data object of Approval user settings. */
export interface UserSettings {
    /** Gets or sets the Version of Request Page.
"V1_0": Request Page Vesion 1 (current).
"V2_0": Request Page Vesion 2 (new). */
    RequestPageVersion?: RequestPageVersion | undefined;
    /** Gets or sets a value indicating whether coach mark should be hidden for request page switch. */
    RequestPageHideCoachmark?: boolean | undefined;
}

/** The enum definition of the request page version. */
export enum RequestPageVersion {
    V1_0 = 1,
    V2_0 = 2,
}

/** Data object outlining response from flow's listApproval API. */
export interface ListApprovalsControllerOutput {
    /** Gets or sets the approval view definition. */
    Value?: ApprovalViewDefinition[] | undefined;
    /** Gets or sets the next link to query to get the remaining results. */
    NextLink?: string | undefined;
}

/** The approval view definition. The properties of this definition are a translation of the approval entity into an object better suited to be consumed by the UI. */
export interface ApprovalViewDefinition {
    /** Gets or sets the name of the approval view. */
    Name?: string | undefined;
    /** Gets or sets the properties of the approval view. */
    Properties?: ApprovalViewProperties | undefined;
}

/** The approval category. */
export enum ApprovalCategory {
    NotSpecified = 0,
    Basic = 1,
    Custom = 2,
}

/** Data object representing environment. */
export interface TeamsEnvironment {
    /** Gets or sets the environment name. */
    Name?: string | undefined;
    /** Gets or sets the environment id. */
    Id?: string | undefined;
    /** Gets or sets the environment location. */
    Location?: string | undefined;
    /** Gets or sets the environment type. */
    Type?: string | undefined;
    /** Gets or sets the type including class and subclass of the persona. */
    Properties: EnvironmentProperty;
}

/** Data object representing environment property. */
export interface EnvironmentProperty {
    /** Gets the environment sisplay name. */
    DisplayName?: string | undefined;
    /** Gets the environment creation time. */
    CreatedTime?: string | undefined;
    /** Gets the environment creation time. */
    EnvironmentSku?: string | undefined;
    /** Gets the environment type. */
    EnvironmentType?: string | undefined;
    /** Gets a value indicating whether the environment is default. */
    IsDefault: boolean;
    /** Gets environment runtime endpoints. */
    RuntimeEndpoints?: EnvironmentRuntimeEndpoints | undefined;
    /** Gets or sets the Dataverse environment metadata. */
    LinkedEnvironmentMetadata?: LinkedEnvironmentMetadata | undefined;
}

/** Data object representing environment. */
export interface EnvironmentRuntimeEndpoints {
    /** Gets or sets the environment name. */
    BusinessAppPlatform?: string | undefined;
    /** Gets or sets the environment type. */
    CommonDataModel?: string | undefined;
    /** Gets or sets the environment id. */
    PowerApps?: string | undefined;
    /** Gets or sets the environment id. */
    PowerAppsAdvisor?: string | undefined;
    /** Gets or sets the environment location. */
    Flow?: string | undefined;
    /** Gets or sets the environment id. */
    ApiManagement?: string | undefined;
}

/** The metadata of the Dataverse environment. */
export interface LinkedEnvironmentMetadata {
    /** Gets or sets the type of the environment. */
    Type?: string | undefined;
    /** Gets or sets the resourceId of the environment,it's usually in Guid format. */
    ResourceId?: string | undefined;
    /** Gets or sets the friendly name of the environment, it's usually same with the DisplayName. */
    FriendlyName?: string | undefined;
    /** Gets or sets the unique name of the environment. */
    UniqueName?: string | undefined;
    /** Gets or sets the domain name of the environment. */
    DomainName?: string | undefined;
    /** Gets or sets the version of the environment. */
    Version?: string | undefined;
    /** Gets or sets the instance url of the environment. Use this url to access Dataverse directly. */
    InstanceUrl?: string | undefined;
    /** Gets or sets the instance API url of the environment. */
    InstanceApiUrl?: string | undefined;
    /** Gets or sets the base language code of the environment. */
    BaseLanguage: number;
    /** Gets or sets the state of the environment. */
    InstanceState?: string | undefined;
    /** Gets or sets the create time of the environment. */
    CreatedTime: string;
}

/** Abstract resource that contains a common set of properties shared among several other resources type. Reference: https://docs.microsoft.com/en-us/graph/api/resources/baseitem?view=graph-rest-1.0. */
export interface BaseItem {
    /** Gets or sets date and time of item creation. */
    CreatedDateTime?: string | undefined;
    /** Gets or sets provides a user-visible description of the item. Optional. */
    Description?: string | undefined;
    /** Gets or sets eTag for the item. */
    ETag?: string | undefined;
    /** Gets or sets id for the item. */
    Id?: string | undefined;
    /** Gets or sets date and time the item was last modified. */
    LastModifiedDateTime?: string | undefined;
    /** Gets or sets the name of the item. Read-write. */
    Name?: string | undefined;
    /** Gets or sets parent information, if the item has a parent. */
    ParentReference?: ItemReference | undefined;
    /** Gets or sets URL that displays the resource in the browser. */
    WebUrl?: string | undefined;
}

/** Abstract resource that contains a common set of properties shared among several other resources type. Reference: https://docs.microsoft.com/en-us/graph/api/resources/driveitem?view=graph-rest-1.0. */
export interface DriveItem extends BaseItem {
    /** Gets or sets an eTag for the content of the item.
This eTag is not changed if only the metadata is changed.
Note This property is not returned if the item is a folder. */
    Ctag?: string | undefined;
    /** Gets or sets remote item data, if the item is shared from a drive other than the one being accessed. */
    RemoteItem?: RemoteItem | undefined;
    /** Gets or sets size of the item being referenced. */
    Size: number;
    /** Gets or sets path that can be used to navigate to the item. */
    Path?: string | undefined;
    /** Gets or sets get webDAV compatible URL for the item. */
    WebDavUrl?: string | undefined;
}

/** Abstract resource that contains a common set of properties shared among several other resources type. */
export interface RemoteItem {
    /** Gets or sets date and time of item creation. */
    CreatedDateTime?: string | undefined;
    /** Gets or sets unique identifier for the remote item in its drive. */
    Id?: string | undefined;
    /** Gets or sets date and time the item was last modified. */
    LastModifiedDateTime?: string | undefined;
    /** Gets or sets name of the item being referenced. */
    Name?: string | undefined;
    /** Gets or sets properties of the parent of the remote item. */
    ParentReference?: ItemReference | undefined;
    /** Gets or sets size of the item being referenced. */
    Size: number;
    /** Gets or sets get webDAV compatible URL for the item. */
    WebDavUrl?: string | undefined;
    /** Gets or sets uRL that displays the resource in the browser. */
    WebUrl?: string | undefined;
}

/** Abstract resource that contains a common set of properties shared among several other resources type. */
export interface ItemReference {
    /** Gets or sets unique identifier of the drive instance that contains the item. */
    DriveId?: string | undefined;
    /** Gets or sets the type of drive. */
    DriveType?: string | undefined;
    /** Gets or sets unique identifier of the item in the drive. */
    Id?: string | undefined;
    /** Gets or sets name of the item being referenced. */
    Name?: string | undefined;
    /** Gets or sets path that can be used to navigate to the item. */
    Path?: string | undefined;
    /** Gets or sets unique identifier for a shared resource that can be accessed via the Shares API. */
    ShareId?: string | undefined;
    /** Gets or sets user's oneDrive Site Id. */
    SiteId?: string | undefined;
}

/** Sharing permission granted for a DriveItem resource. */
export interface Permission {
    /** Gets or sets id for the item. */
    Id?: string | undefined;
    /** Gets or sets item sharing token. */
    ShareId?: string | undefined;
    /** Gets or sets the link details. */
    Link?: SharingLink | undefined;
    /** Gets or sets the expiration time of the permission. */
    ExpirationDateTime: string;
    /** Gets or sets a value indicating whether the password is set for this permission. */
    HasPassword: boolean;
}

/** Document sharing link. */
export interface SharingLink {
    /** Gets or sets a value indicating whether download is allowed. */
    PreventsDownload: boolean;
    /** Gets or sets the type of the link created. */
    Type?: string | undefined;
    /** Gets or sets the scope of the link created. */
    Scope?: string | undefined;
    /** Gets or sets the links for embend the item in a webpage. */
    WebHtml?: string | undefined;
    /** Gets or sets URL that opens the item in the browser. */
    WebUrl?: string | undefined;
}

/** The class model of ODSP Share Link Option. */
export interface ODSPShareLinkOption {
    /** Gets or sets share link Type. */
    Type?: string | undefined;
    /** Gets or sets document password. */
    Password?: string | undefined;
    /** Gets or sets document URL expiration date time. */
    ExpirationDateTime?: string | undefined;
    /** Gets or sets document sharing URL scope. */
    Scope?: string | undefined;
}

/** The class model of ODSP Share Link Option. */
export interface CreateShareLinkInput {
    /** Gets or sets document URL expiration date time. */
    ExpirationDateTime?: string | undefined;
    /** Gets or sets document path url. */
    FilePath?: string | undefined;
    /** Gets or sets share link Type. */
    Type: ShareLinkType;
    /** Gets or sets document sharing URL scope. */
    Scope: ShareLinkScope;
}

/** The types for ODSP sharing link. */
export enum ShareLinkType {
    View = 0,
    Review = 1,
    Edit = 2,
    Embed = 3,
    BlocksDownload = 4,
    CreateOnly = 5,
    AddressBar = 6,
    AdminDefault = 7,
}

/** The scope for ODSP sharing link. */
export enum ShareLinkScope {
    Anonymous = 0,
    Organization = 1,
    Users = 2,
}

/** Data object representing people results. */
export interface PeopleResult {
    /** Gets or sets the person/user's User's Display Name. */
    UserDisplayName?: string | undefined;
    /** Gets or sets the person/user's AAD Object ID. */
    UserAadObjectId?: string | undefined;
    /** Gets or sets the person/user's UPN. */
    UserUPN?: string | undefined;
    /** Gets or sets the person/user's email. */
    Email?: string | undefined;
    /** Gets or sets the type including class and subclass of the persona. */
    PersonType: PersonType;
}

/** The PersonType Graph Object. */
export interface PersonType {
    /** Gets or sets the id of a Person. */
    Class: string;
    /** Gets or sets the person display name, keep this string and not SubclassTypeEnum
as we donot have the full list of possible values in SubclassTypeEnum. De-serialization will fail. */
    Subclass: string;
}

/** Input passed along for the people search APIs. */
export interface PeopleResultsControllerInput {
    /** Gets or sets the query text for the people search. */
    QueryText?: string | undefined;
}

/** The flow subscription type. */
export interface ApprovalProvisioningInfo {
    /** Gets or sets provisioning state. */
    State: ApprovalProvisioningState;
    /** Gets or sets features supported by the deployed version of the database. */
    SupportedFeatures?: ApprovalsFeature[] | undefined;
    /** Gets or sets the provisioning message. */
    Message?: string | undefined;
}

/** Enumeration of possible database states. */
export enum ApprovalProvisioningState {
    Unknown = 0,
    NotProvisioned = 1,
    InProgress = 2,
    Ready = 3,
    Error = 4,
}

/** Features offered by Approvals beyond the baseline. */
export enum ApprovalsFeature {
    NotSpecified = 0,
    AllowCancel = 1,
    CustomResponseOptions = 2,
    AllowReassign = 3,
    Attachments = 4,
    AllowAssignToTeam = 5,
    TemplateSchema = 6,
    ApprovalPartnerMetadata = 7,
    EmailRequestId = 8,
    SequentialApproval = 9,
    ApprovalRequestPartnerMetadata = 10,
    AdditionalFields = 11,
    MultiStageApproval = 12,
}

/** Data object outlining response from flow's responseApproval API. */
export interface ReassignApprovalControllerOutput {
    /** Gets or sets the id of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval. */
    Properties?: ApprovalViewProperties | undefined;
}

/** Data object used to call the reassign approval handler. */
export interface ReassignApprovalControllerInput {
    /** Gets or sets the assigned to. */
    AssignedTo?: string | undefined;
    /** Gets or sets the approval Id. */
    ApprovalId: string;
    /** Gets or sets the approval request Id. */
    ApprovalRequestId: string;
    /** Gets or sets the input properties of an reassign (response) call. */
    Properties?: ReassignApprovalInputProperties | undefined;
    /** Gets or sets the ClientRequestId for approvalrequest. */
    ClientRequestId: string;
    /** Gets or sets the environment id for Approval is created. */
    FlowEnvironment?: string | undefined;
}

/** Properties of the data object used to call the reassign (response) approval handler. */
export interface ReassignApprovalInputProperties {
    /** Gets or sets the response of the approval. */
    Response?: string | undefined;
    /** Gets or sets the comment of the approval. */
    Comments?: string | undefined;
}

/** Data object for send reminder handler. */
export interface SendReminderControllerOutput {
    /** Gets or sets the approval request id. */
    ApprovalId: string;
}

/** Input data object for send reminder controller. */
export interface SendReminderControllerInput {
    /** Gets or sets the approval request id. */
    ApprovalId: string;
    /** Gets or sets the title of the approval request. */
    Title?: string | undefined;
    /** Gets or sets the environment. */
    FlowEnvironment?: string | undefined;
    /** Gets or sets the array of AAD IDs of pending approvers. */
    PendingApprovers?: string[] | undefined;
    /** Gets or sets the name of requester of the approval. */
    Requester?: string | undefined;
    /** Gets or sets a value indicating from where approval is created. */
    ApprovalCreator: ApprovalCreator;
    /** Gets or sets the MessageId of the bot message posted while creating the approval request. */
    MessageId?: string | undefined;
    /** Gets or sets the ConversationId of the bot message posted while creating the approval request. */
    ConversationId?: string | undefined;
    /** Gets or sets the ChannelId of the bot message posted while creating the approval request. */
    ChannelId?: string | undefined;
    /** Gets or sets the AADGroupId of teams team. */
    AadGroupId?: string | undefined;
}

/** Data object of Request Settings. */
export interface RequestSettings {
    /** Gets or sets a value indicating whether coach mark should be hidden for request page switch. */
    CommentsRequired?: boolean | undefined;
}

/** The Esign provider settings object. */
export interface ProviderFlags {
    /** Gets or sets a value indicating whether the adobe sign provider is set. */
    AdobeSignProvider: boolean;
    /** Gets or sets a value indicating whether the Docusign provider is enabled. */
    DocusignProvider: boolean;
    /** Gets or sets a value indicating whether the Request Comments sign provider is set. */
    RequestCommentsProvider: boolean;
}

/** Data object representing the graph representation for tag results. */
export interface TeamTagResult {
    /** Gets or sets the team tag Id. */
    Id?: string | undefined;
    /** Gets or sets the ID of team in which the tag is defined. */
    TeamId: string;
    /** Gets or sets the tag's name. */
    DisplayName?: string | undefined;
    /** Gets or sets the tag's description. */
    Description?: string | undefined;
    /** Gets or sets the number of users assigned to the tag. */
    MemberCount: number;
    /** Gets or sets the type of tag. */
    TagType?: string | undefined;
    /** Gets or sets the team tag members. */
    Members?: TeamTagMember[] | undefined;
    /** Gets or sets whether channel membership could not be checked completely. */
    ChannelMembersCouldNotBeChecked?: boolean | undefined;
}

/** Data object representing the member of team tag. */
export interface TeamTagMember {
    /** Gets or sets the member displayName. */
    DisplayName?: string | undefined;
    /** Gets or sets the member userId. */
    UserId?: string | undefined;
    /** Gets or sets the member photo. */
    Thumbnail?: string | undefined;
}

/** Input passed along for the tag search APIs. */
export interface SearchTeamTagResultsControllerInput {
    /** Gets or sets the query text for the tags search in a team. */
    QueryText?: string | undefined;
    /** Gets or sets the optional channel context used to constrain host-team tags. */
    CurrentChannelId?: string | undefined;
}

/** expand value for GetTeamTagDetailController. */
export enum ExpandValue {
    NotSpecified = 0,
    Members = 1,
    MembersWithPhoto = 2,
}

/** Data object outlining response from flow's responseApproval API. */
export interface UpdateApprovalControllerOutput {
    /** Gets or sets the name of the approval response. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval response. */
    Id?: string | undefined;
    /** Gets or sets the entity type name, for this case it would be ApprovalResponse. */
    Type?: string | undefined;
    /** Gets or sets the properties of the approval. */
    Properties?: UpdateApprovalOutputProperties | undefined;
}

/** Data object of the properties of the update response from flow. */
export interface UpdateApprovalOutputProperties {
    /** Gets or sets stage of the approval. */
    Stage?: string | undefined;
    /** Gets or sets status of the response. */
    Status: ApprovalResponseStatus;
    /** Gets or sets creation date of the approval. */
    CreationDate: string;
    /** Gets or sets the identity of the user that responds. */
    Owner?: UserPrincipal | undefined;
    /** Gets or sets response of the approval. */
    Response?: string | undefined;
    /** Gets or sets comments of the approval. */
    Comments?: string | undefined;
}

/** The state of an approval response. */
export enum ApprovalResponseStatus {
    NotSpecified = 0,
    Reviewing = 1,
    Saved = 2,
    Committed = 3,
}

/** Data object used to call the update approval handler. */
export interface UpdateApprovalControllerInput {
    /** Gets or sets the approval Id. */
    ApprovalId: string;
    /** Gets or sets the input properties of an update (response) call. */
    Properties?: UpdateApprovalInputProperties | undefined;
    /** Gets or sets the ClientRequestId for approvalrequest. */
    ClientRequestId: string;
    /** Gets or sets the environment id for Approval is created. */
    FlowEnvironment?: string | undefined;
}

/** Properties of the data object used to call the update (response) approval handler. */
export interface UpdateApprovalInputProperties {
    /** Gets or sets the response of the approval. */
    Response?: string | undefined;
    /** Gets or sets the comment of the approval. */
    Comments?: string | undefined;
    /** Gets or sets the additional field responses. */
    AdditionalFields?: { [key: string]: string; } | undefined;
}

/** Represents an audit event. */
export interface AuditEvent {
    /** Gets or sets the approval request type. */
    SignApprovalType: SignApprovalType;
    /** Gets or sets the event type. */
    EventType: AuditEventType;
    /** Gets or sets the envelope id. */
    EnvelopeId?: string | undefined;
    /** Gets or sets the external id. */
    ExternalId?: string | undefined;
    /** Gets or sets the client request id. */
    ClientRequestId?: string | undefined;
}

/** The types of e-sign approvals that users can create, maps to the Provider drop down within eSign Request Type in UI.. */
export enum SignApprovalType {
    Adobe = 0,
    Docusign = 1,
}

/** Enum for audit event type. */
export enum AuditEventType {
    DocusignEditEnvelope = 0,
    DocusignReviewEnvelope = 1,
    AdobeReviewEnvelope = 2,
}

/** Controller output for sending envelope as an adaptive card. Holds the message id. */
export interface CreateAdaptiveCardControllerOutput {
    /** Gets or sets the message id. */
    MessageId?: string | undefined;
}

/** Controller input for sending an adaptive card. */
export interface CreateAdaptiveCardControllerInput {
    /** Gets or sets the user name. */
    UserName?: string | undefined;
    /** Gets or sets the user email. */
    UserEmail?: string | undefined;
    /** Gets or sets the client request id. */
    ClientRequestId: string;
    /** Gets or sets the webhook data object. */
    WebhookBaseDataObject?: WebhookBaseDataObject | undefined;
    /** Gets or sets the sign approval type. */
    SignApprovalType: SignApprovalType;
}

/** Base class for callback data. */
export interface WebhookBaseDataObject {
    /** Gets or sets the ServiceUrl of the bot message posted while creating the approval request.. */
    ServiceUrl?: string | undefined;
    /** Gets or sets the MessageId of the bot message posted while creating the approval request. */
    MessageId?: string | undefined;
    /** Gets or sets the ConversationId of the bot message posted while creating the approval request. */
    ConversationId?: string | undefined;
    /** Gets or sets the ChannelId of the bot message posted while creating the approval request. */
    ChannelId?: string | undefined;
    /** Gets or sets a value indicating from where approval is created. */
    ApprovalCreator: ApprovalCreator;
    /** Gets or sets the AADGroupId of teams team. */
    AadGroupId?: string | undefined;
    /** Gets or sets the cultureInfo when adaptive card is created. */
    Culture?: string | undefined;
    /** Gets or sets the MRI(BotUserId) of creator of Approvals. */
    MRI?: string | undefined;
    /** Gets or sets the approval event type. */
    Type?: string | undefined;
    /** Gets or Sets the Approval Type. */
    ApprovalType: ApprovalType;
}

/** Controller input for deleting adaptive cards. */
export interface DeleteAdaptiveCardControllerInput {
    /** Gets or sets the webhook base data object. */
    WebhookBaseDataObject?: WebhookBaseDataObject | undefined;
    /** Gets or sets the sign approval type. */
    SignApprovalType: SignApprovalType;
}

export class ServiceException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isServiceException = true;

    static isServiceException(obj: any): obj is ServiceException {
        return obj.isServiceException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ServiceException(message, status, response, headers, null);
}

/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 *
 *  Base Class for auto-generated nSwag code under `../gen/index.ts`. The code in this file can be modified if needed,
 *  but make sure to run the build of Approvals.SFApp/Approvals.Service to update the auto-generated code, and check in
 *  the auto-generated code as well.
 *
 *  The auto-generated code under `../gen/index.ts` is the code that actually gets to run.
 */

declare const MIDDLE_TIER_ENDPOINT: string;